export const queryKeys = {
  base: () => ['addons'] as const,
  list: () => [...queryKeys.base(), 'list' as const],
  // switcher is a child of the full list key so the addon mutations, which
  // invalidate list(), also refresh the sidebar switcher (React Query prefix
  // match) — an install/enable/uninstall updates the launchable products.
  switcher: () => [...queryKeys.list(), 'switcher' as const],
  detail: (id: string) => [...queryKeys.base(), 'detail' as const, id],
  versions: (id: string) => [...queryKeys.base(), id, 'versions' as const],
  values: (id: string, version: string) => [
    ...queryKeys.base(),
    id,
    'values' as const,
    version,
  ],
};
